import { RecurrenceEditorComponent } from '@syncfusion/ej2-react-schedule'
import { useEffect, useRef } from 'react'

export const useRecurrenceEditorStyle = () => {
  const recurrenceRef = useRef<RecurrenceEditorComponent>(null)

  useEffect(() => {
    const ruleEditorGrandParent = recurrenceRef?.current?.element
    if (ruleEditorGrandParent) {
      const ruleEditorParent = ruleEditorGrandParent.children[0] as HTMLElement
      ruleEditorGrandParent.style.gridColumn = '1 / 5'

      ruleEditorParent.style.display = 'grid'
      ruleEditorParent.style.gridTemplateColumns = '35% 35% 1fr'
      ruleEditorParent.style.gridTemplateRows = '3rem 1fr'
      ruleEditorParent.style.alignItems = 'start'
      ruleEditorParent.style.gridGap = '1rem'

      const repeatControl = ruleEditorParent.getElementsByClassName('e-input-wrapper e-form-left')[0] as HTMLElement
      repeatControl.style.width = '100%'
      repeatControl.style.padding = '0'
      repeatControl.style.lineHeight = '2rem'

      const repeatEveryControl = ruleEditorParent.getElementsByClassName('e-input-wrapper e-interval e-form-right')[0] as HTMLElement
      repeatEveryControl.style.width = '100%'
      repeatEveryControl.style.padding = '0'
      repeatEveryControl.style.lineHeight = '2rem'
      repeatEveryControl.style.alignItems = 'start'

      const label = repeatEveryControl.getElementsByTagName('label')
      label[0].style.overflow = 'visible'

      const table = repeatEveryControl.getElementsByTagName('table')
      table[0].style.borderSpacing = '0px'

      const repeatOnControl = ruleEditorParent.getElementsByClassName('e-input-wrapper-side e-days e-form-left')[0] as HTMLElement
      repeatOnControl.style.padding = '0'
      repeatOnControl.style.lineHeight = '2rem'
      repeatOnControl.style.gridRow = '-1'
      repeatOnControl.style.gridColumn = '1 / 4'
      repeatOnControl.style.width = '75%'
      repeatOnControl.style.marginLeft = '15%'

      const endTypeControl = ruleEditorParent.getElementsByClassName(
        'e-input-wrapper-side e-non-week e-form-left e-hide-recurrence-element'
      )[0] as HTMLElement
      endTypeControl.style.width = '100%'
      endTypeControl.style.padding = '0'
      endTypeControl.style.lineHeight = '2rem'
      endTypeControl.style.gridRow = '-1'
      endTypeControl.style.gridColumn = '1 / 4'
      Array.prototype.slice.call(endTypeControl.children).forEach((grandChild: HTMLElement) => {
        grandChild.style.padding = '0px'
      })
      const endControl =
        (ruleEditorParent.getElementsByClassName('e-input-wrapper-side e-end-on e-form-right')[0] as HTMLElement) ||
        (ruleEditorParent.getElementsByClassName('e-input-wrapper-side e-end-on e-form-left')[0] as HTMLElement)

      endControl.style.width = '100%'
      endControl.style.marginBottom = '0px'
      endControl.style.gridRow = '1'
      endControl.style.gridColumn = '3 / 4'
      endControl.style.padding = '0px'
      endControl.style.paddingTop = '3px'
      Array.prototype.slice.call(endControl.children).forEach((grandChild) => {
        if (grandChild.innerHTML === 'End') grandChild.innerHTML = 'Last Occurrence'
        grandChild.style.padding = '0px'
        grandChild.style.width = '100%'
      })
    }
  }, [recurrenceRef.current])

  return recurrenceRef
}
